import { A } from '@adornis/base/env-info.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import type { NarrowedEntityData } from '@adornis/bh-util/selectionset-types.js';
import { Language } from '@adornis/translation-core/languages.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class TextMultipleLangItem extends AdornisEntity {
  static override _class = 'TextMultipleLangItem';

  static override resolveID() {
    return A.getGloballyUniqueID();
  }

  static findByLanguage(
    translations: NarrowedEntity<TextMultipleLangItem, { langKey: 1; text: 1 }>[],
    targetLang: Language = Language.GERMAN,
  ) {
    if (!translations || !translations.length) return;
    return translations.find(t => t.langKey === targetLang);
  }

  static mapAllTranslationsByLang(
    translations: NarrowedEntityData<TextMultipleLangItem, { langKey: 1; text: 1 }>[] | undefined | null,
  ) {
    if (!translations) return {};

    return translations.reduce((mapped, curTranslation) => {
      // Aktuelle überschreibt vorherige Uebersetzung, wenn dublikte vorhanden sind
      mapped[curTranslation.langKey] = curTranslation.text;

      return mapped;
    }, {} as { [k in Language]?: string });
  }

  constructor(doc: PartialEntityData<TextMultipleLangItem>) {
    super(doc);
  }

  @validate(nonOptional())
  @Field(type => String)
  langKey!: Language;

  @validate(nonOptional())
  @Field(type => String)
  text!: string;
}
